import {Hex} from 'viem';

export enum LocalStorageKeys {
  SHOW_INSTALL_AS_STANDALONE_IOS = 'show-install-as-standalone-ios',
  VERIFIED_THROUGH_WHITELIST = 'shareland-webapp-verified-through-whitelist',
  IS_WAGMI_WEB3_AUTH_USER_LOGGED_IN = 'is-wagmi-web3-auth-user-logged-in',
  SHOW_INFO_TILE = 'show-info-tile-',
}

const parseBool = (str: string): boolean => ['true', 'TRUE'].includes(str);

const baseGetEnv = (envName: string) => {
  const variable = import.meta.env[envName];
  if (variable !== undefined) {
    return variable;
  } else {
    throw new Error(`Missing ${envName} environment variable`);
  }
};
const getEnv = {
  String: (key: string): string => baseGetEnv(key),
  Int: (key: string): number => parseInt(baseGetEnv(key)),
  Float: (key: string): number => parseFloat(baseGetEnv(key)),
  Boolean: (key: string): boolean => parseBool(baseGetEnv(key)),
};

const isWaitlistNet = getEnv.Boolean('VITE_IS_WAITLIST_NET') || window.location.hostname === 'exchange.share.land';
const amplitudeApiKey =
  window.location.hostname === 'exchange.share.land'
    ? getEnv.String('VITE_AMPLITUDE_KEY_PROD')
    : getEnv.String('VITE_AMPLITUDE_KEY_QA');

const environment = {
  mapboxAccessToken: getEnv.String('VITE_MAPBOX_ACCESS_TOKEN'),
  apiUrl: getEnv.String('VITE_API_URL'),
  assetUrl: getEnv.String('VITE_PUBLIC_ASSET_URL'),
  chainKey: getEnv.String('VITE_CHAIN_KEY'),
  sentryEnvironmentName: getEnv.String('VITE_SENTRY_ENVIRONMENT_NAME'),
  sentryDsn: getEnv.String('VITE_SENTRY_DSN'),
  stableTokenAddress: getEnv.String('VITE_STABLE_TOKEN_ADDRESS') as Hex,
  web3AuthClientId: getEnv.String('VITE_WEB3AUTH_CLIENT_ID'),
  alchemyHttpsUrl: getEnv.String('VITE_ALCHEMY_HTTPS_URL'),
  alchemyWssUrl: getEnv.String('VITE_ALCHEMY_WSS_URL'),
  segmentIOApiKey: getEnv.String('VITE_SEGMENT_IO_API_KEY'),
  brazeApiKey: getEnv.String('VITE_BRAZE_API_KEY'),
  amplitudeApiKey,
  brazeBaseUrl: getEnv.String('VITE_BRAZE_BASE_URL'),
  celliAIAgentId: getEnv.String('VITE_CELLI_AI_AGENT_ID'),
  isWaitlistNet,
  loginOpenLoginEnabled: isWaitlistNet ? true : getEnv.Boolean('VITE_LOGIN_OPEN_LOGIN_ENABLED'),
  loginMetamaskEnabled: isWaitlistNet ? true : getEnv.Boolean('VITE_LOGIN_METAMASK_ENABLED'),
  usdcContract: getEnv.String('VITE_USDC_CONTRACT'),
} as const;

export default environment;
